import { render } from "./afterSales.vue?vue&type=template&id=d16fdeb4&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=d16fdeb4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d16fdeb4"]])

export default __exports__